import { Redirect } from "react-router-dom";

//Redux
import { connect } from "react-redux";

const RedirectRoute = ({ isAuthenticated, isBlocked }) => {
  if (isAuthenticated) {
    if (isBlocked) {
      return <Redirect from="*" to="/block" />;
    } else {
      return <Redirect from="*" to="/dashboard" />;
    }
  } else {
    return <Redirect from="*" to="/" />;
  }
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
};

export default connect(mapStateToProps)(RedirectRoute);
